export const groupBy = <T>(array: T[], fn: (arg: T) => string | undefined) =>
  array.reduce((result: Record<string, T[]>, item: T) => {
    const key = fn(item)
    if (key && !result[key]) {
      result[key] = []
    }
    key && result[key].push(item)
    return result
  }, {})
